import { jsx as e } from "react/jsx-runtime";

import { forwardRef as r, useMemo as o } from "react";

import t from "./hooks/useModel.js";

import a from "./formatters.js";

import s from "./context.js";

import n from "./components/index.js";

const i = r((({value: r, onChange: i, onError: m, format: l, inline: f, transformBeforeChange: d, isDateDisabled: u, disableFuture: p, disablePast: b, labelId: c, ...h}, j) => {
    const g = t({
        value: r,
        onChange: i,
        onError: m,
        transformBeforeChange: d,
        isDateDisabled: u,
        format: l,
        inline: f,
        labelId: c,
        disableFuture: p,
        disablePast: b
    }), v = o((() => ({
        model: g,
        components: n,
        formatters: a
    })), []);
    return e(s.Provider, {
        value: v,
        children: e(n.Root, {
            ...h,
            ref: j
        })
    });
}));

export { i as default };
//# sourceMappingURL=index.js.map
